/**
 * Minified by jsDelivr using Terser v5.19.2.
 * Original file: /gh/kms0219kms/jquery-confirm@master/js/jquery-confirm.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
